import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  PAYMENT_METHODS_INDEX_REQUESTED,
  PAYMENT_METHODS_INDEX_SUCCESS,
  PAYMENT_METHODS_INDEX_FAILURE,

  PAYMENT_METHOD_CREATE_REQUESTED,
  PAYMENT_METHOD_CREATE_SUCCESS,
  PAYMENT_METHOD_CREATE_FAILURE,

  PAYMENT_METHOD_UPDATE_REQUESTED,
  PAYMENT_METHOD_UPDATE_SUCCESS,
  PAYMENT_METHOD_UPDATE_FAILURE,

  PAYMENT_METHOD_DELETE_REQUESTED,
  PAYMENT_METHOD_DELETE_SUCCESS,
  PAYMENT_METHOD_DELETE_FAILURE,

} from '../types';

export const paymentMethodsIndexRequested = () => {
  return {
    type: PAYMENT_METHODS_INDEX_REQUESTED
  }
};

export const paymentMethodsIndexSuccess = (paymentMethods) => {
  return {
    type: PAYMENT_METHODS_INDEX_SUCCESS,
    payload: paymentMethods
  }
};

export const paymentMethodsIndexFailure = () => {
  return {
    type: PAYMENT_METHODS_INDEX_FAILURE
  }
};

export const paymentMethodCreateRequested = () => {
  return {
    type: PAYMENT_METHOD_CREATE_REQUESTED
  }
};

export const paymentMethodCreateSuccess = (paymentMethod) => {
  return {
    type: PAYMENT_METHOD_CREATE_SUCCESS,
    paymentMethod: paymentMethod
  }
};

export const paymentMethodCreateFailure = () => {
  return {
    type: PAYMENT_METHOD_CREATE_FAILURE
  }
};

export const paymentMethodUpdateRequested = () => {
  return {
    type: PAYMENT_METHOD_UPDATE_REQUESTED
  }
};

export const paymentMethodUpdateSuccess = (paymentMethod) => {
  return {
    type: PAYMENT_METHOD_UPDATE_SUCCESS,
    paymentMethod: paymentMethod
  }
};

export const paymentMethodUpdateFailure = () => {
  return {
    type: PAYMENT_METHOD_UPDATE_FAILURE
  }
};


export const paymentMethodDeleteRequested = (paymentMethodId) => {
  return {
    type: PAYMENT_METHOD_DELETE_REQUESTED,
    paymentMethodId: paymentMethodId
  }
};

export const paymentMethodDeleteSuccess = () => {
  return {
    type: PAYMENT_METHOD_DELETE_SUCCESS
  }
};

export const paymentMethodDeleteFailure = () => {
  return {
    type: PAYMENT_METHOD_DELETE_FAILURE
  }
};


export const paymentMethodsIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(paymentMethodsIndexRequested());

    let endPoint = Config.baseUrl + Config.paymentMethods;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(paymentMethodsIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentMethodsIndexFailure());
      });
  }
}

export const paymentMethodCreate = (signedPayload, paymentMethod) => {
  return (dispatch) => {
    dispatch(paymentMethodCreateRequested());

    let endPoint = Config.baseUrl + Config.paymentMethod;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { paymentMethod: paymentMethod }, { headers: headers })
      .then((response) => {
        dispatch(paymentMethodCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentMethodCreateFailure());
      });

  }
}

export const paymentMethodUpdate = (signedPayload, paymentMethodId, paymentMethod) => {
  return (dispatch) => {
    dispatch(paymentMethodUpdateRequested());

    let endPoint = Config.baseUrl + Config.paymentMethod;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { paymentMethodId: paymentMethodId, paymentMethod: paymentMethod }, { headers: headers })
      .then((response) => {
        dispatch(paymentMethodUpdateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentMethodUpdateFailure());
      });

  }
}

export const paymentMethodDisable = (signedPayload, paymentMethodId) => {
  return (dispatch) => {
    dispatch(paymentMethodDeleteRequested(paymentMethodId));

    let endPoint = Config.baseUrl + Config.paymentMethod + paymentMethodId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(paymentMethodDeleteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentMethodDeleteFailure());
      });
  }
}